import {
  Badge,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Theme,
  Typography,
} from '@mui/material';
import { NotificationsIcon } from '~/shared/components/Icons/Icons';

export function NotificationTrigger({
  hasNewNotifications,
  onClick,
}: {
  hasNewNotifications: boolean;
  onClick: () => void;
}) {
  return (
    <ListItem disablePadding>
      <ListItemButton
        onClick={onClick}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          color: (theme: Theme) => theme.palette.text.secondary,
          '&:hover': {
            color: (theme: Theme) => theme.palette.text.primary,
            backgroundColor: 'unset',
          },
        }}
        disableRipple
      >
        <ListItemIcon
          sx={{
            display: 'flex',
            justifyContent: 'center',
            color: 'inherit',
            mb: 1,
          }}
        >
          <Badge
            color="error"
            variant="dot"
            invisible={!hasNewNotifications}
            overlap="circular"
            sx={{ '& .MuiBadge-badge': { top: 4, right: 4 } }}
          >
            <NotificationsIcon />
          </Badge>
        </ListItemIcon>

        <ListItemText
          primary={
            <Typography variant="body-xs" sx={{ textAlign: 'center' }}>
              Notifications
            </Typography>
          }
        />
      </ListItemButton>
    </ListItem>
  );
}
